const ANT_DESIGN_KEYWORDS: string[] = [
  'ResizeObserver loop' // Explained by PR https://bitbucket.org/farmbotteam/farmbot-web-app/pull-requests/1426
];

const GOOGLE_MAPS_API_KEYWORDS: string[] = [
  'maps.googleapis.com'
];

const RTSP_STREAM_KEYWORDS: string[] = [
  'DECODE_Stop' // Explained by PR https://bitbucket.org/farmbotteam/farmbot-web-app/pull-requests/1503
];

export const ROLLBAR_IGNORED_KEYWORDS: string[] = [
  ...ANT_DESIGN_KEYWORDS,
  ...GOOGLE_MAPS_API_KEYWORDS,
  ...RTSP_STREAM_KEYWORDS
];